module.exports = __webpack_public_path__ + "um.9a3630828a4e8116fe53.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/um.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/um.svg
// module chunks = styles